<template>
  <div class="card" :class="{ favourite: isFavourite }">
    <div class="card__body">
      <header class="card__header">
        <h3 class="card__number">
          {{ $t('apartment') }}
          <b>{{ flat[flatProperties['id']].toUpperCase() }}</b>
        </h3>
      </header>

      <div
        v-if="withButtons"
        @click="clickCard"
        class="card__image"
        :class="{ clickable: withButtons }"
      >
        <img
          v-if="planURL"
          :src="planURL"
          alt
          @error="
            () => {
              planError = true;
            }
          "
        />
        <p class="card__noimg" v-else>{{ $t('singleFlat.noPrev') }}</p>
      </div>
      <router-link v-else :to="flatURL" class="card__image">
        <img
          v-if="planURL"
          :src="planURL"
          alt
          @error="
            () => {
              planError = true;
            }
          "
        />
        <p class="card__noimg" v-else>{{ $t('singleFlat.noPrev') }}</p>
      </router-link>

      <div class="card__info">
        <div class="card__data">
          <p class="card__label">{{ $t('singleFlat.area') }}:</p>
          <p class="card__value">
            <span>{{ flat[flatProperties['area']] }} m<sup>2</sup></span>
          </p>
        </div>
        <div class="card__data">
          <p class="card__label">{{ $t('singleFlat.floor') }}:</p>
          <p class="card__value">{{ flat[flatProperties['floor']] }}</p>
        </div>
        <div class="card__data">
          <p class="card__label">{{ $t('rooms') }}:</p>
          <p class="card__value">
            {{ flat[flatProperties['rooms']] }}
          </p>
        </div>
        <div class="card__status" :class="status">
          {{ getStatus(flat[flatProperties['status']]) }}
        </div>
      </div>
      <div
        v-if="withButtons"
        class="card__buttons"
        :class="{ column: isLangDE }"
      >
        <button v-if="isDesktop" @click="handleFirstButton" type="button">
          <svg
            v-if="isDesktop && isFavourite"
            height="18"
            width="18"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m11.466 22.776c.141.144.333.224.534.224s.393-.08.534-.224l9.594-9.721c4.001-4.053 1.158-11.055-4.532-11.055-3.417 0-4.985 2.511-5.596 2.98-.614-.471-2.172-2.98-5.596-2.98-5.672 0-8.55 6.984-4.531 11.055z"
            />
          </svg>
          <svg
            v-if="isDesktop && !isFavourite"
            height="18"
            width="18"
            viewBox="0 -28 512.001 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m256 455.515625c-7.289062 0-14.316406-2.640625-19.792969-7.4375-20.683593-18.085937-40.625-35.082031-58.21875-50.074219l-.089843-.078125c-51.582032-43.957031-96.125-81.917969-127.117188-119.3125-34.644531-41.804687-50.78125-81.441406-50.78125-124.742187 0-42.070313 14.425781-80.882813 40.617188-109.292969 26.503906-28.746094 62.871093-44.578125 102.414062-44.578125 29.554688 0 56.621094 9.34375 80.445312 27.769531 12.023438 9.300781 22.921876 20.683594 32.523438 33.960938 9.605469-13.277344 20.5-24.660157 32.527344-33.960938 23.824218-18.425781 50.890625-27.769531 80.445312-27.769531 39.539063 0 75.910156 15.832031 102.414063 44.578125 26.191406 28.410156 40.613281 67.222656 40.613281 109.292969 0 43.300781-16.132812 82.9375-50.777344 124.738281-30.992187 37.398437-75.53125 75.355469-127.105468 119.308594-17.625 15.015625-37.597657 32.039062-58.328126 50.167969-5.472656 4.789062-12.503906 7.429687-19.789062 7.429687zm-112.96875-425.523437c-31.066406 0-59.605469 12.398437-80.367188 34.914062-21.070312 22.855469-32.675781 54.449219-32.675781 88.964844 0 36.417968 13.535157 68.988281 43.882813 105.605468 29.332031 35.394532 72.960937 72.574219 123.476562 115.625l.09375.078126c17.660156 15.050781 37.679688 32.113281 58.515625 50.332031 20.960938-18.253907 41.011719-35.34375 58.707031-50.417969 50.511719-43.050781 94.136719-80.222656 123.46875-115.617188 30.34375-36.617187 43.878907-69.1875 43.878907-105.605468 0-34.515625-11.605469-66.109375-32.675781-88.964844-20.757813-22.515625-49.300782-34.914062-80.363282-34.914062-22.757812 0-43.652344 7.234374-62.101562 21.5-16.441406 12.71875-27.894532 28.796874-34.609375 40.046874-3.453125 5.785157-9.53125 9.238282-16.261719 9.238282s-12.808594-3.453125-16.261719-9.238282c-6.710937-11.25-18.164062-27.328124-34.609375-40.046874-18.449218-14.265626-39.34375-21.5-62.097656-21.5zm0 0"
            />
          </svg>
          {{ isFavourite ? $t('removeFromFavs') : $t('addToFavs') }}
        </button>
        <button @click="handleFormClick" type="button">
          {{ $t('form.title') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'flat-card',
  props: ['flat', 'withButtons'],
  data() {
    return {
      planError: false,
      isDesktop: true,
    };
  },
  methods: {
    ...mapMutations({
      addToFavourites: 'ADD_TO_FAVOURITES',
      deleteFromFavourites: 'DELETE_FROM_FAVOURITES',
    }),
    clickCard(e) {
      const clickedButton =
        e.target.tagName === 'BUTTON' ||
        e.target.tagName.toUpperCase() === 'PATH' ||
        e.target.parentNode.tagName === 'BUTTON';

      if (this.isDesktop && !clickedButton) {
        window.top.postMessage(
          `GO_TO_FLAT/${this.flat[this.flatProperties['id']]}`,
          '*'
        );
      }
    },
    toggleTour() {
      window.top.postMessage(
        `TOUR3D/${this.flat[this.flatProperties['id']]}`,
        '*'
      );
      this.$emit('toggleTour', {
        source: this.flat.tour3D,
        flat: this.flat[this.flatProperties['id']],
      });
    },
    handleFirstButton() {
      if (this.isDesktop) {
        window.top.postMessage(
          `TOGGLE_FAVOURITE/${this.flat[this.flatProperties['id']]}`,
          '*'
        );
        window.top.postMessage(
          `${!this.isFavourite ? `ADD_FAVOURITE` : `REMOVE_FAVOURITE`}/${
            this.flat[this.flatProperties['id']]
          }`,
          '*'
        );
      } else {
        this.toggleTour();
      }
    },
    handleFormClick() {
      this.$emit('toggleForm', this.flat[this.flatProperties['id']]);
      window.top.postMessage(
        `ZAPYTAJ_O_MIESZKANIE/${this.flat[this.flatProperties['id']]}`,
        '*'
      );
    },
  },
  created() {
    if (window.innerWidth < 992) {
      this.isDesktop = false;
    }
  },
  computed: {
    ...mapState({ flatProperties: state => state.browser.flatProperties }),
    ...mapGetters({
      getPlan: 'GET_PLAN',
      investmentURL: 'GET_INVESTMENT_URL',
      getStatus: 'GET_STATUS_NAME',
    }),
    status() {
      return this.$store.getters.GET_STATUS_CLASS(
        this.flat[this.flatProperties['status']]
      );
    },
    isLangDE() {
      return this.$t('singleFlat.area') === 'Bereich';
    },
    id() {
      return this.flat[this.flatProperties['id']].toUpperCase();
    },
    planURL() {
      if (this.planError) {
        return false;
      }
      if (!this.flat) return false;

      return this.getPlan(this.flat[this.flatProperties['realID']]);
    },
    flatURL() {
      if (this.flat.investment)
        return `/${this.flat.investment.url}/flat/${
          this.flat[this.flatProperties['id']]
        }`;
      return `/${this.investmentURL}/flat/${
        this.flat[this.flatProperties['id']]
      }`;
    },
    isFavourite() {
      let favs = this.$store.getters.GET_FAVOURITES.map(fav => {
        if (fav) {
          return fav.investments_number;
        }
        return '';
      });
      return favs.includes(this.flat[this.flatProperties['id']]);
    },
  },
};
</script>

<style lang="scss">
sup {
  font-size: 10px;
  vertical-align: super;
}

.card {
  width: 100%;
  height: auto;
  background: #fff;
  border: 1px solid $lightGray;
  border-radius: 0;
  position: relative;
  padding: 16px;
  transition: 250ms;
  overflow: hidden;

  &.favourite {
    border-color: $primaryColor;
  }

  &:hover {
    border-color: $primaryColor;
    box-shadow: 0 0 50px rgba(#000000, 0.15);
  }
}

.card__body {
  width: 100%;
  height: 100%;
}

.card__header {
  // border-bottom: 1px solid $lightGray;
}

.card__number {
  text-align: left;
  font-weight: 400;
  font-size: 22px;
  b {
    font-weight: 600;
  }
}

.card__status {
  font-weight: 500;
  font-size: 14px;

  &.available {
    color: $available;
  }

  &.reserved {
    color: $reserved;
  }

  &.sold {
    color: $sold;
  }
}

.card__noimg {
  font-size: 14px;
  text-align: center;
  @media screen and (max-width: $sm) {
    font-size: 10px;
  }
}

.card__image {
  position: relative;
  width: 100%;
  height: 150px;
  margin: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #000000;
  font-size: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid $lightGray;
  &.clickable {
    cursor: pointer;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.card__info {
  margin-top: 4px;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 6px;
  align-items: flex-end;
}

.card__buttons {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-top: 10px;
  & > button {
    width: 100%;
    margin: 5px 0;
    min-width: 140px;
    font-weight: 500;
    font-size: 12px;
  }
  @media (min-width: 992px) {
    flex-direction: column;
    justify-content: space-between;
    & > button {
      margin: 0;
      width: auto;
    }
    & > button:first-child {
      margin: 0 0 10px 0;
    }
    &.column {
      flex-direction: column;
      button:first-child {
        margin: 0 0 10px 0;
      }
    }
  }
  @media (min-width: 1200px) {
    flex-direction: row;
    & > button:first-child {
      margin: 0 5px 0 0;
    }
  }
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    border: 1px solid $primaryColor;
    font-family: 'Montserrat';
    background: transparent;
    cursor: pointer;
    transition: 0.3s;
    color: #000;
    &:nth-child(1) {
      &:hover {
        background: $primaryColor;
        color: #fff;
      }
    }
    svg {
      margin-right: 8px;
      fill: $primaryColor;
      transition: 0.3s;
    }
    &:hover {
      svg {
        fill: #fff;
      }
    }
    &:nth-child(2) {
      background: $primaryColor;
      color: #fff;
      &:hover {
        background: transparent;
        color: #000;
      }
    }
  }
}

.card__data {
  display: contents;
  align-items: center;
  margin: 4px auto;
}

.card__value {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
}

.card__value-floor {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 15px;
  height: 15px;
  border-radius: 50%;
  cursor: pointer;
  padding-top: 2px;
  &:hover {
    color: $primaryColor;
  }
  &.active {
    color: white;
    background: $primaryColor;
  }
}

.card__label {
  font-size: 12px;
  margin-right: 6px;
  color: #6f6f6f;
  text-transform: uppercase;
  font-weight: 600;
}

.card__line {
  border: 0.5px solid rgba(#000000, 0.04);
}

.card__favourite {
  position: absolute;
  top: 0;
  left: 0;
  border: none;
  background: $primaryColor;
  padding: 12px 10px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transform: translate(-25%, -25%);
}

.card__view-buttons {
  position: absolute;
  top: 10px;
  right: 0;
  display: flex;
  flex-direction: column;
}

.card__plan-button {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background: transparent;
  color: $primaryColor;
  border: 1px solid $primaryColor;
  padding: 13px 10px 10px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  transition: 0.25s;
  & + & {
    border-top: none;
  }
  svg {
    fill: $primaryColor;
    transition: 0.25s;
  }
  &.active {
    background: $primaryColor;
    color: #fff;
    svg {
      fill: #fff;
    }
  }
  &:hover {
    span {
      opacity: 1;
      visibility: visible;
      transform: scale(1) translate(0, -50%);
    }
  }
  span {
    display: block;
    padding: 2px 5px;
    white-space: nowrap;
    position: absolute;
    font-size: 11px;
    top: 50%;
    right: 45px;
    z-index: 1;
    transition: 0.25s;
    background: #fff;
    color: #000;
    font-weight: 500;
    border: 1px solid $lightGray;
    opacity: 0;
    transform: scale(0.7) translate(20px, -50%);
    visibility: hidden;
    border-radius: 4px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
  }
}
</style>
